export const LIST_CART_BY_USERID = /* GraphQL */ `
  query listCartByUserId($limit: Int, $nextToken: String) {
    listCartByUserId(limit: $limit, nextToken: $nextToken) {
      count
      nextToken
      items {
        horseId
        score
        createdAt
        saddleId
        updatedAt
        userId
        brandName
        productData {
          pk
          sk
          type
          createdAt
          discipline
          manufacturerMeasurements {
            gulletWidth
            gulletHeight
            barAngle
          }
          measurements {
            gulletWidth
            gulletHeight
            barAngle
          }
          newOrUsed
          price
          photo
          productTitle
          gallery
          quantity
          size
          status
          description
          score
          updatedAt
          variantId
          userId
        }
      }
    }
  }
`;
